var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "station-header",
          attrs: { "body-style": { padding: "14px" } },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-page-header",
                    {
                      attrs: {
                        content:
                          _vm.type == "add"
                            ? "新增考勤组页面"
                            : "编辑考勤组页面",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          attrs: { slot: "title" },
                          on: { click: _vm.backFn },
                          slot: "title",
                        },
                        [
                          _c("i", { staticClass: "el-icon-arrow-left" }),
                          _vm._v("\n            返回\n          "),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-card", { staticClass: "card-box mt14" }, [
        _c("div", { staticClass: "step" }, [
          _c(
            "span",
            {
              staticClass: "public",
              class: _vm.activeIndex == 1 ? "active" : "",
            },
            [_vm._v("1")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "step-text",
              class: _vm.activeIndex == 1 ? "activeText" : "",
            },
            [_vm._v("考勤信息")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "line-title" }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "public",
              class: _vm.activeIndex == 2 ? "active" : "",
            },
            [_vm._v("2")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "step-text",
              class: _vm.activeIndex == 2 ? "activeText" : "",
            },
            [_vm._v("考勤地点")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "line-title" }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "public",
              class: _vm.activeIndex == 3 ? "active" : "",
            },
            [_vm._v("3")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "step-text",
              class: _vm.activeIndex == 3 ? "activeText" : "",
            },
            [_vm._v("考勤规则")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "line-title" }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "public",
              class: _vm.activeIndex == 4 ? "active" : "",
            },
            [_vm._v("4")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "step-text",
              class: _vm.activeIndex == 4 ? "activeText" : "",
            },
            [_vm._v("排班周期")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main" },
          [
            _vm.activeIndex == 1
              ? _c(
                  "div",
                  { staticClass: "alert" },
                  [
                    _c("el-alert", {
                      staticClass: "cr-alert",
                      attrs: {
                        description:
                          "新增考勤组点击所有步骤中的「上一步」「下一步」按钮，均会自动保存考勤组信息，并进行页面跳转！",
                        "show-icon": "",
                        type: "info",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: { "label-width": "120px" },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _vm.activeIndex == 1
                  ? [
                      _c("div", { staticClass: "from-item-title mb15" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("setting.info.essentialinformation"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-box" }, [
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", { staticClass: "color-tab" }, [
                                      _vm._v("* "),
                                    ]),
                                    _vm._v("考勤组名称："),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请输入考勤组名称",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.from.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.from, "name", $$v)
                                    },
                                    expression: "from.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", { staticClass: "color-tab" }, [
                                      _vm._v("* "),
                                    ]),
                                    _vm._v("考勤人员："),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.from.type,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.from, "type", $$v)
                                      },
                                      expression: "from.type",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        staticClass: "mb14",
                                        attrs: { label: "1" },
                                      },
                                      [_vm._v("按部门添加")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "tips" }, [
                                      _vm._v(
                                        "用于本部门所有人员均需参加考勤的情况；若所选择的部门有新员工加入，则该人员自动加入考勤人员之中"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "0" } }, [
                                      _vm._v("按人员添加"),
                                    ]),
                                    _c("span", { staticClass: "tips" }, [
                                      _vm._v(
                                        " 用于特殊个例人员需要参加考勤的情况"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", { staticClass: "color-tab" }, [
                                      _vm._v("* "),
                                    ]),
                                    _vm._v(
                                      "需要考勤" +
                                        _vm._s(
                                          _vm.from.type == 1 ? "部门" : "人员"
                                        ) +
                                        "："
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.from.type == 0
                                  ? _c("select-member", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        value: _vm.userList || [],
                                        placeholder: "选择需要考勤人员",
                                      },
                                      on: {
                                        getSelectList: function ($event) {
                                          return _vm.getSelectList($event, 3)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.from.type == 1
                                  ? _c("select-department", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        value: _vm.frames || [],
                                        placeholder: "选择需要考勤部门",
                                      },
                                      on: {
                                        changeMastart: function ($event) {
                                          return _vm.changeMastart($event, 3)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.eliminateList.length !== 0
                                  ? _c("span", { staticClass: "tips" }, [
                                      _vm._v(
                                        "选择人员中，有" +
                                          _vm._s(_vm.eliminateList.length) +
                                          "人由于已经加入其他考勤组，未添加成功\n                  "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "color-doc",
                                          on: { click: _vm.openJoin },
                                        },
                                        [_vm._v("点击查看")]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [_vm._v("排除考勤成员：")]
                                ),
                                _vm._v(" "),
                                _c("select-member", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    value: _vm.filterList || [],
                                    placeholder: "请选择人员",
                                  },
                                  on: {
                                    getSelectList: function ($event) {
                                      return _vm.getSelectList($event, 2)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "tips" }, [
                                  _vm._v(
                                    "请选择不在本考勤组成员，但需在其他考勤组进行考勤的人员"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", { staticClass: "color-tab" }, [
                                      _vm._v("* "),
                                    ]),
                                    _vm._v("考勤组管理员："),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("select-member", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    value: _vm.adminList || [],
                                    placeholder: "请选择人员",
                                  },
                                  on: {
                                    getSelectList: function ($event) {
                                      return _vm.getSelectList($event, 1)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "tips" }, [
                                  _vm._v(
                                    "考勤组管理员，可以编辑考勤组规则，也可导出和查看考勤组数据，一般选择人事或排班管理人员"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "from-item-title mb15" }, [
                        _c("span", [_vm._v("考勤班次")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-box" }, [
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c("span", { staticClass: "color-tab" }, [
                                    _vm._v("* "),
                                  ]),
                                  _vm._v("考勤班次："),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "select plan-footer-one",
                                  on: { click: _vm.openShift },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex-box" },
                                    _vm._l(
                                      _vm.shiftsList,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "shift-tag",
                                            style: {
                                              backgroundColor: item.color,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(item.name) +
                                                "\n                      " +
                                                _vm._s(
                                                  item.times[0]
                                                    .first_day_after == 0
                                                    ? "当日"
                                                    : "次日"
                                                ) +
                                                " " +
                                                _vm._s(
                                                  item.times[0].work_hours
                                                ) +
                                                " -\n                      " +
                                                _vm._s(
                                                  item.times[0]
                                                    .second_day_after == 0
                                                    ? "当日"
                                                    : "次日"
                                                ) +
                                                _vm._s(
                                                  item.times[0].off_hours
                                                ) +
                                                "\n                      "
                                            ),
                                            item.times.length > 1
                                              ? _c("span", [
                                                  _vm._v(
                                                    "、 " +
                                                      _vm._s(
                                                        item.times[1]
                                                          .first_day_after == 0
                                                          ? "当日"
                                                          : "次日"
                                                      ) +
                                                      "\n                        " +
                                                      _vm._s(
                                                        item.times[1].work_hours
                                                      ) +
                                                      " - " +
                                                      _vm._s(
                                                        item.times[1]
                                                          .second_day_after == 0
                                                          ? "当日"
                                                          : "次日"
                                                      ) +
                                                      _vm._s(
                                                        item.times[1].off_hours
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "tips" }, [
                                _vm._v("未排班时，员工可选择班次打卡"),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeIndex == 2
                  ? [
                      _c("div", { staticClass: "from-item-title mb10 mt14" }, [
                        _c("span", [_vm._v("选择考勤范围")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mapBox" }, [
                        _c(
                          "div",
                          { staticClass: "map" },
                          [
                            _c("mapContainer", {
                              attrs: { positionInfo: _vm.from },
                              on: { select: _vm.selectMap },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "map pl60" },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "invoice-body",
                                attrs: { "label-width": "110px" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "form-item" },
                                  [
                                    _c("el-form-item", [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v("考勤详细地址：")]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.from.address)),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-item" },
                                  [
                                    _c("el-form-item", [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v("经纬度坐标：")]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.from.lng) +
                                            "  " +
                                            _vm._s(_vm.from.lat)
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-item" },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "label" },
                                            slot: "label",
                                          },
                                          [_vm._v("有效范围：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              id: "tipinput",
                                              size: "small",
                                            },
                                            model: {
                                              value: _vm.from.effective_range,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.from,
                                                  "effective_range",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "from.effective_range",
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticStyle: {
                                                  "font-style": "normal",
                                                  "margin-right": "10px",
                                                },
                                                attrs: { slot: "suffix" },
                                                slot: "suffix",
                                              },
                                              [_vm._v("米")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "from-item-title mb15 mt14" },
                              [_c("span", [_vm._v("设置地点名称")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", { staticClass: "color-tab" }, [
                                      _vm._v("* "),
                                    ]),
                                    _vm._v("考勤地点名称："),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticStyle: { width: "350px" },
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请输入地点",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.from.location_name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.from, "location_name", $$v)
                                    },
                                    expression: "from.location_name",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", { staticClass: "tips" }, [
                                    _vm._v(
                                      "该名称会在打卡手机端显示，便于员工识别打卡地点"
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeIndex == 3
                  ? [
                      _c("div", { staticClass: "from-item-title mb15" }, [
                        _c("span", [_vm._v("补卡")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.from.repair_allowed,
                            callback: function ($$v) {
                              _vm.$set(_vm.from, "repair_allowed", $$v)
                            },
                            expression: "from.repair_allowed",
                          },
                        },
                        [_vm._v("允许补卡")]
                      ),
                      _vm._v(" "),
                      _vm.from.repair_allowed
                        ? _c("div", { staticClass: "form-box" }, [
                            _c(
                              "div",
                              { staticClass: "form-item" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { "label-width": "100px" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [_vm._v("补卡类型：")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.from.repair_type,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.from,
                                              "repair_type",
                                              $$v
                                            )
                                          },
                                          expression: "from.repair_type",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: "1" } },
                                          [_vm._v("缺卡")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: "2" } },
                                          [_vm._v("迟到")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: "3" } },
                                          [_vm._v("严重迟到")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: "4" } },
                                          [_vm._v("早退")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: "5" } },
                                          [_vm._v("地点异常")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { "label-width": "100px" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [_vm._v("补卡时间：")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value: _vm.from.is_limit_time,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.from,
                                              "is_limit_time",
                                              $$v
                                            )
                                          },
                                          expression: "from.is_limit_time",
                                        },
                                      },
                                      [_vm._v("限制补卡时间")]
                                    ),
                                    _vm._v(" "),
                                    _vm.from.is_limit_time
                                      ? _c(
                                          "div",
                                          { staticClass: "fz12" },
                                          [
                                            _vm._v(
                                              "\n                  可申请过去\n                  "
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "120px" },
                                              attrs: {
                                                max: 365,
                                                min: 0,
                                                "controls-position": "right",
                                              },
                                              model: {
                                                value: _vm.from.limit_time,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.from,
                                                    "limit_time",
                                                    $$v
                                                  )
                                                },
                                                expression: "from.limit_time",
                                              },
                                            }),
                                            _vm._v(
                                              "\n                  天内的补卡 填写0天，则只能发起当天的补卡\n                "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { "label-width": "100px" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [_vm._v("补卡次数：")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value: _vm.from.is_limit_number,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.from,
                                              "is_limit_number",
                                              $$v
                                            )
                                          },
                                          expression: "from.is_limit_number",
                                        },
                                      },
                                      [_vm._v("限制补卡次数")]
                                    ),
                                    _vm._v(" "),
                                    _vm.from.is_limit_number
                                      ? _c(
                                          "div",
                                          { staticClass: "fz12" },
                                          [
                                            _vm._v(
                                              "\n                  每人每月补卡次数上限\n                  "
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "120px" },
                                              attrs: {
                                                max: 30,
                                                min: 0,
                                                "controls-position": "right",
                                              },
                                              model: {
                                                value: _vm.from.limit_number,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.from,
                                                    "limit_number",
                                                    $$v
                                                  )
                                                },
                                                expression: "from.limit_number",
                                              },
                                            }),
                                            _vm._v(
                                              "\n                  次\n                "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "from-item-title mb15" }, [
                        _c("span", [_vm._v("拍照打卡")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.from.is_photo,
                            callback: function ($$v) {
                              _vm.$set(_vm.from, "is_photo", $$v)
                            },
                            expression: "from.is_photo",
                          },
                        },
                        [_vm._v("拍照打卡")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "pl24 mb20" }, [
                        _c("span", { staticClass: "tips" }, [
                          _vm._v(
                            "勾选之后，员工范围内上下班打卡时均需拍照，照片会存档"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "from-item-title mb15" }, [
                        _c("span", [_vm._v("外勤打卡")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.from.is_external,
                            callback: function ($$v) {
                              _vm.$set(_vm.from, "is_external", $$v)
                            },
                            expression: "from.is_external",
                          },
                        },
                        [_vm._v("允许外勤打卡")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "pl24 mb20" }, [
                        _c("span", { staticClass: "tips" }, [
                          _vm._v(
                            "勾选之后，允许员工不在考勤范围使用外勤打卡，外勤打卡会在打卡报表中体现"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.from.is_external
                        ? _c("div", { staticClass: "mb20 pl24" }, [
                            _c(
                              "span",
                              [
                                _vm._v("外勤打卡备注必填："),
                                _c("el-switch", {
                                  attrs: {
                                    "active-text": "开启",
                                    "inactive-text": "关闭",
                                  },
                                  model: {
                                    value: _vm.from.is_external_note,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.from,
                                        "is_external_note",
                                        $$v
                                      )
                                    },
                                    expression: "from.is_external_note",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.from.is_external
                        ? _c("div", { staticClass: "pl24" }, [
                            _c(
                              "span",
                              [
                                _vm._v("外勤打卡必须拍照："),
                                _c("el-switch", {
                                  attrs: {
                                    "active-text": "开启",
                                    "inactive-text": "关闭",
                                  },
                                  model: {
                                    value: _vm.from.is_external_photo,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.from,
                                        "is_external_photo",
                                        $$v
                                      )
                                    },
                                    expression: "from.is_external_photo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeIndex == 4
                  ? [
                      _c("div", { staticClass: "from-item-title mb15" }, [
                        _c("span", [_vm._v("排班周期")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "tips" }, [
                          _vm._v("排班周期适用于上一休一、三班倒等规律性排班"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "add-row",
                          on: { click: _vm.addCycleFn },
                        },
                        [
                          _c("span", { staticClass: "el-icon-plus" }),
                          _vm._v(" 新增排班周期"),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          staticClass: "mb20",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.tableData },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "周期名称",
                              prop: "name",
                              width: "180",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "周期班次",
                              prop: "shifts",
                              width: "180",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.shifts
                                                .map(function (obj) {
                                                  return obj.name
                                                })
                                                .join("、")
                                            )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3694413736
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "周期天数", prop: "cycle" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              fixed: "right",
                              label: "操作",
                              width: "180",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editFn(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteFn(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              840297846
                            ),
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cr-bottom-button" },
        [
          _vm.activeIndex !== 1
            ? _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.activeIndex = _vm.activeIndex - 1
                    },
                  },
                },
                [_vm._v("上一步")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeIndex !== 4
            ? _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.nextStep()
                    },
                  },
                },
                [_vm._v("下一步")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeIndex == 4
            ? _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v("保存")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("add-cycle", { ref: "addCycle", on: { cycleList: _vm.getCycleList } }),
      _vm._v(" "),
      _c("shift-list", { ref: "shiftList", on: { selected: _vm.selected } }),
      _vm._v(" "),
      _c("not-join", {
        ref: "notJoin",
        on: { otherFiltersFn: _vm.otherFiltersFn },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }